import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import data from './data';
import Firebase from 'src/Firebase.js'
import FreightOrderTableWrapper from './FreightOrderTableWrapper';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const FreightOrderListView = () => {
  const classes = useStyles();
  const [customers] = useState(data);

  useEffect(() => {
    // Update the document title using the browser API

    
  });


  return (
    <Page
      className={classes.root}
      title="Freight Orders"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
         <div id='fk11'>
          <FreightOrderTableWrapper customers={customers}/>
          </div>
          

        </Box>
      </Container>
    </Page>
  );
};

export default FreightOrderListView;
